/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { Accordion, Spinner } from 'react-bootstrap';
import {
  ListItemsComp,
  TextComp,
  HtmlComp,
  TableComp,
  CheckLists,
} from './components';

import { MultiColList } from '../MultiColList';

import { TimelineMercury } from '@vlinder-web/timeline-mercury-widget-react';
import { CheckedItems } from '../CheckedItems';
import { IconListComp } from '../IconList';
import { MediaListComp } from '../MediaList';

import * as S from './styles';
import { MediaCarousel } from '../MediaCarousel';

export interface accordionItems {
  type:
    | 'text'
    | 'markup'
    | 'list'
    | 'multi-col-list'
    | 'timeline'
    | 'check-list'
    | 'icon'
    | 'media';
  title: string;
  data: any;
  styleProps: any;
}

export interface IAccordionProps {
  data: accordionItems[];
  timelineCardClick?(id: string): void;
  _onCarouselImageClick?(item: any): void;
  [key: any]: any;
}

export const AccordionComp = (props: IAccordionProps) => {
  const { data, timelineCardClick, _onCarouselImageClick, ...rest } = props;

  const _getBody = (item) => {
    switch (item?.type) {
      case 'list':
        return <ListItemsComp listItems={item?.data} />;
      case 'timeline':
        return (
          <TimelineMercury items={item?.data} onItemClick={timelineCardClick} />
        );
      case 'text':
        return <TextComp {...item} />;
      case 'markup':
        return <HtmlComp {...item} />;
      case 'multi-col-list':
        return <MultiColList {...item} />;
      case 'check-list':
        return <CheckLists {...item} />;
      case 'icon':
        return <IconListComp {...item} />;
      case 'media':
        return <MediaListComp {...item} />;
      case 'media-carousel':
        return (
          <MediaCarousel
            {...item}
            onCarouselImageClick={_onCarouselImageClick}
          />
        );
      default:
        return null;
    }
  };
  const _getAccordionBody = (item) => {
    if (Array.isArray(item)) {
      return <>{item?.map((_item) => _getBody(_item))}</>;
    }
    return _getBody(item);
  };

  const _renderAccordion = (item: listItems) => {
    const _item = Array.isArray(item) && item?.length > 0 ? item?.[0] : item;
    return (
      <S.AccordionComponent
        defaultActiveKey={_item?.title}
        style={S.AccordionStyle}
        className="mt-2"
      >
        <Accordion.Item eventKey={_item?.title}>
          <Accordion.Header style={S.HeaderStyle}>
            <h6 className="fw-bold p-2">{_item?.title}</h6>
          </Accordion.Header>
          <hr />
          <Accordion.Body>{_getAccordionBody(item)}</Accordion.Body>
        </Accordion.Item>
      </S.AccordionComponent>
    );
  };
  return (
    <>
      {Array.isArray(data) &&
        data?.map((item: listItems) => {
          return <>{_renderAccordion(item)}</>;
        })}
    </>
  );
};

AccordionComp.defaultProps = {};
